// extracted by mini-css-extract-plugin
export var layoutContainer = "_4d-0";
export var layoutContainerNoRounding = "_4d-6";
export var layoutContainerOpen = "_4d-5";
export var layoutContainerResizing = "_4d-1";
export var mainContent = "_4d-2";
export var resizeDivider = "_4d-3";
export var slidePanel = "_4d-4";